import { create } from "zustand";

type ToastState = {
  open: boolean;
  title?: string;
  message?: string;
  status?: "success" | "loading" | "error" | "warning";
  action?: {
    label: string;
    onClick: () => void;
  };
  show: (payload: {
    title: string;
    message?: string;
    durationMs?: number;
    countdown?: { endsAt: number; title: (seconds: number) => string };
    status?: "success" | "loading" | "error" | "warning";
    action?: {
      label: string;
      onClick: () => void;
    };
  }) => void;
  clear: () => void;
};

export type ToastPayload = Parameters<ToastState["show"]>[0];

let toastTimeout: number | null = null;
let countdownInterval: number | null = null;

export const useToastStore = create<ToastState>((set) => ({
  open: false,
  title: undefined,
  message: undefined,
  status: "success",
  action: undefined,
  show: ({
    title,
    message,
    durationMs = 3000,
    status = "success",
    action,
    countdown,
  }) => {
    if (toastTimeout) {
      window.clearTimeout(toastTimeout);
      toastTimeout = null;
    }
    if (countdownInterval !== null) window.clearInterval(countdownInterval);
    countdownInterval = null;
    if (countdown) {
      durationMs = Math.max(0, countdown.endsAt - Date.now());
      title = countdown.title(Math.ceil(durationMs / 1000));
      countdownInterval = window.setInterval(() => {
        set({
          title: countdown.title(
            Math.max(0, Math.ceil((countdown.endsAt - Date.now()) / 1000)),
          ),
        });
      }, 250);
    }
    set({ open: true, title, message, status, action });
    toastTimeout = window.setTimeout(() => {
      if (countdownInterval !== null) window.clearInterval(countdownInterval);
      countdownInterval = null;
      set({
        open: false,
        title: undefined,
        message: undefined,
        status: "success",
        action: undefined,
      });
      toastTimeout = null;
    }, durationMs);
  },
  clear: () => {
    if (countdownInterval !== null) window.clearInterval(countdownInterval);
    countdownInterval = null;
    if (toastTimeout) {
      window.clearTimeout(toastTimeout);
      toastTimeout = null;
    }
    set({
      open: false,
      title: undefined,
      message: undefined,
      status: "success",
      action: undefined,
    });
  },
}));
